// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/img/wave-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/img/Hero-pic.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../assets/icons/user.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../assets/icons/email.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../assets/icons/lock.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.registrationFormContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  touch-action: pan-y;
  background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgb(0, 47, 72)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: repeat-x;
}
.registrationFormContainer .registrationCard {
  width: 340px;
  padding: 20px;
  position: relative;
}
.registrationFormContainer .registrationCard .heroPic {
  width: 100%;
  height: 260px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
.registrationFormContainer .registrationCard .cardTitle {
  text-align: center;
  color: #FFFFFF;
  position: absolute;
  font-family: "Bitter", serif;
  font-size: 42px;
  font-weight: 700;
  left: 50%;
  margin-left: -60px;
  top: 13%;
  margin-top: -50px;
}
.registrationFormContainer .registrationCard .signUpTitle {
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  color: #699BB6;
  font-size: 30px;
}
.registrationFormContainer .registrationCard .signInMessage {
  margin-bottom: 30px;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
  color: #699BB6;
  font-size: 14px;
}
.registrationFormContainer .registrationCard .signInMessage .signInLink {
  color: #FFFFFF;
}
.registrationFormContainer .registrationCard .site-form-item-icon {
  color: rgba(0, 0, 0, 0.25);
}
.registrationFormContainer .registrationCard .ant-input-affix-wrapper {
  border-radius: 10px;
  padding: 11px;
}
.registrationFormContainer .registrationCard .userIcon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
}
.registrationFormContainer .registrationCard .emailIcon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
}
.registrationFormContainer .registrationCard .lockIcon {
  width: 16px;
  height: 16px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
}
.registrationFormContainer .registrationCard .registrationButton {
  width: 100%;
  padding: 24px;
  background: linear-gradient(to right, #6D4ECB, #FF6B6B);
  text-align: center;
  color: #FFFFFF;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}
.registrationFormContainer .registrationCard button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}
.registrationFormContainer .registrationCard .ant-form-item-explain-error {
  font-size: 12px;
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/modules/auth/signUp/index.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/fonts.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,0HAAA;EACA,2BAAA;AADJ;AAGE;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AADN;AAEM;EACE,WAAA;EACA,aAAA;EACA,yDAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;AAAR;AAEM;EACE,kBAAA;EACA,cC1BK;ED2BL,kBAAA;EACA,4BE3BC;EF4BD,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAAR;AAGM;EACE,kBAAA;EACA,iCElCC;EFmCD,gBAAA;EACA,cCxCS;EDyCT,eAAA;AADR;AAIM;EACE,mBAAA;EACA,kBAAA;EACA,iCE3CC;EF4CD,gBAAA;EACA,cCjDS;EDkDT,eAAA;AAFR;AAGQ;EACE,cCrDG;ADoDb;AAIM;EACE,0BAAA;AAFR;AAIM;EACE,mBAAA;EACA,aAAA;AAFR;AAIM;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;AAFR;AAIM;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;AAFR;AAKM;EACE,WAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;AAHR;AAMM;EACE,WAAA;EACA,aAAA;EACA,uDAAA;EACA,kBAAA;EACA,cCxFK;EDyFL,iCEpFC;EFqFD,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAJR;AAOM;EACE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AALR;AAQM;EACE,eAAA;EACA,UAAA;AANR","sourcesContent":["@import \"../../../scss/fonts.scss\";\n@import \"../../../scss/colors.scss\";\n\n.registrationFormContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100dvh;\n    touch-action:pan-y;\n    background-image: linear-gradient(180deg, rgba(0, 84, 130, 0.87), rgba(0, 47, 72, 1)),url('../../../assets/img/wave-pattern.png');\n    background-repeat:repeat-x;\n \n  .registrationCard{\n      width: 340px;\n      padding: 20px;\n      position: relative;\n      .heroPic{\n        width: 100%;\n        height: 260px;\n        background-image:url('../../../assets/img/Hero-pic.png');\n        background-size: cover;\n        background-repeat:no-repeat;\n        background-position: center;\n      }\n      .cardTitle{\n        text-align: center;\n        color: $color-White;\n        position: absolute;\n        font-family: $Bitter;\n        font-size: 42px;\n        font-weight:700;\n        left: 50%;\n        margin-left: -60px;\n        top: 13%;\n        margin-top: -50px;\n      }\n\n      .signUpTitle{\n        text-align: center;\n        font-family: $Roboto;\n        font-weight: 500;\n        color: $color-Secondary;\n        font-size: 30px;\n      }\n\n      .signInMessage{\n        margin-bottom: 30px;\n        text-align: center;\n        font-family: $Roboto;\n        font-weight: 500;\n        color: $color-Secondary;\n        font-size: 14px;\n        .signInLink{\n          color: $color-White;\n        }\n      }\n      .site-form-item-icon {\n        color: rgba(0, 0, 0, 0.25);\n      }\n      .ant-input-affix-wrapper{\n        border-radius: 10px;\n        padding: 11px;\n      }\n      .userIcon{\n        width:16px;\n        height: 16px;\n        background-image: url('../../../assets/icons/user.png');\n        background-size: cover;\n      }\n      .emailIcon{\n        width:16px;\n        height: 16px;\n        background-image: url('../../../assets/icons/email.png');\n        background-size: cover;\n\n      }\n      .lockIcon{\n        width:16px;\n        height: 16px;\n        background-image: url('../../../assets/icons/lock.png');\n        background-size: cover;\n\n      }\n      .registrationButton {\n        width: 100%;\n        padding: 24px;\n        background: linear-gradient(to right, $color-Gradient-3-1, $color-Gradient-2-2);\n        text-align: center;\n        color: $color-White;\n        font-family: $Roboto;\n        font-weight: 400;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 10px;\n      }\n\n      button{\n        background: none;\n        color: inherit;\n        border: none;\n        padding: 0;\n        font: inherit;\n        cursor: pointer;\n        outline: inherit;\n      }\n\n      .ant-form-item-explain-error {\n        font-size: 12px;\n        color: red;\n      }\n    }\n  \n  \n   \n  }\n  ","$color-White:#FFFFFF;\n$color-Secondary:#699BB6;\n\n$color-Gradient-1-2:#002F48;\n$color-Gradient-2-2:#FF6B6B;\n$color-Gradient-3-2:#987EE4;\n$color-Gradient-4-2:#F595DF; \n$color-Gradient-5-2:#FEA5A5;\n\n$color-Gradient-1-1:#216B93;\n$color-Gradient-2-1:#F595DF;\n$color-Gradient-3-1:#6D4ECB;\n$color-Gradient-4-1:#C465AE;\n\n","@import url('https://fonts.googleapis.com/css2?family=Alfa+Slab+One&family=Bitter:wght@400;700;900&family=Crimson+Pro:wght@700;900&family=Noto+Serif:wght@900&family=Roboto:wght@400;500;700;900&display=swap');\n$Bitter: 'Bitter', serif;   \n$Crimson-Pro: 'Crimson Pro', serif;\n$Alfa-Slab-One: 'Alfa Slab One', serif;\n$Noto-Serif: 'Noto Serif', serif;\n$Roboto: 'Roboto', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
